import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ContactView from "@/views/ContactView.vue";
import PaymentView from "@/views/PaymentView.vue";
import GrillePaymentView from "@/views/GrillePaymentView.vue";
import QrLink from "../views/qrLink.vue"
import Comptoir from "../views/comptoir.vue"
import StandTouch from "../views/standTouch.vue"


const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  
  {
    path: "/qrLink",
    name: "qrLink",
    component: QrLink,
  },
  {
    path: "/standTouch",
    name: "standTouch",
    component: StandTouch,
  },
  {
    path: "/comptoir",
    name: "comptoir",
    component: Comptoir,
  },
  
  {
    path: "/contact",
    name: "Contact",
    component: ContactView,
  },
  {
    path: "/:id/payment",
    name: "Paiement",
    component: PaymentView,
  },
  {
    path: "/:id/grillePayment",
    name: "GrillePayment",
    component: GrillePaymentView,
  },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
